
<template>
    <div>
        <ValidationObserver ref="addI20FileForm">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6" >
                <ValidationProvider name="endorsed_i20" rules="required"  v-slot="{valid, errors}">
                    <b-form-group :label="$t('upload')">
                        <div class="d-flex custom-file-upload">
                            <b-form-file v-model="endorsed_i20"
                                         :state="errors[0] ? false : (valid ? true : null)"
                                         :placeholder="$t('select_file')"
                                         :drop-placeholder="$t('drop_file')"
                                         ref="fileInput"
                                         accept="application/pdf"
                            />
                            <b-button variant="outline-secondary"
                                      @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                            </b-button>
                        </div>
                        <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                    </b-form-group>
                </ValidationProvider>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import OutOfCountryMentoraServices from "@/services/OutOfCountryMentoraServices";

export default {
    name: "I20UploadFile",
    data(){
        return {
            endorsed_i20:null,
            isLoading:false
        }
    },
    methods:{
        async uploadFile(){
            const isValid =await this.$refs.addI20FileForm.validate()
            if(!isValid) return false
            const formData =new FormData()
            formData.append('endorsed_i20',this.endorsed_i20)
            this.isLoading=true
            try {
                await OutOfCountryMentoraServices.i20Upload(this.$route.params.id,formData)
                return  true
            }catch (err){
                this.showErrors(err,this.$refs.addI20FileForm)
                return false
            }
        }
    }
}
</script>

<style scoped>

</style>
